import "./index.css";
import React, { useEffect, Suspense, lazy } from "react"; // Import Suspense and lazy
import { Routes, Route } from "react-router-dom";
// Remove AOS imports (explained in Step 3)

// Component Imports
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";

// --- Lazy Load Pages ---

// Main Pages
const Home = lazy(() => import("./Pages/home"));
const Contact = lazy(() => import("./Pages/contact"));

// "About Islamabad" Group
const AboutIslamabad = lazy(() => import("./Pages/about-islamabad"));
const PopulationDemographics = lazy(() => import("./Pages/population-demographics"));
const ResidentialAreas = lazy(() => import("./Pages/residential-areas"));
const CommercialAreas = lazy(() => import("./Pages/commercial-areas"));
const SectorsOverview = lazy(() => import("./Pages/sectors-overview"));
const AirportSocieties = lazy(() => import("./Pages/airport-societies"));
const BlueWorldCity = lazy(() => import("./Pages/blue-world-city"));

// "Investment Guide" Group
const InvestmentOpportunities = lazy(() => import("./Pages/investment-opportunities"));
const HousingSchemesStatus = lazy(() => import("./Pages/housing-schemes-status"));
const FutureGrowth = lazy(() => import("./Pages/future-growth"));
const PrivateSocieties = lazy(() => import("./Pages/private-societies"));
const WhyInvest = lazy(() => import("./Pages/why-invest"));

const DragonMall = lazy(() => import("./Pages/dragon-mall"));

// "Blog / Insights" Group
const Blog = lazy(() => import("./Pages/blog"));
const BlogPost = lazy(() => import("./Pages/blog-post"));

// Loading Component
const PageLoader = () => (
  <div className="h-screen w-full flex items-center justify-center bg-white">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary"></div>
  </div>
);

function App() {
  // Removed AOS init (See Step 3)

  return (
    <>
      <Navbar />
      <main>
        {/* Wrap Routes in Suspense to handle the loading state */}
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* --- Core Routes --- */}
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />

            {/* --- "About Islamabad" Routes --- */}
            <Route path="/about-islamabad" element={<AboutIslamabad />} />
            <Route path="/blue-world-city" element={<BlueWorldCity />} />
            <Route path="/population-demographics" element={<PopulationDemographics />} />
            <Route path="/residential-areas" element={<ResidentialAreas />} />
            <Route path="/commercial-areas" element={<CommercialAreas />} />
            <Route path="/sectors-overview" element={<SectorsOverview />} />
            <Route path="/airport-societies" element={<AirportSocieties />} />
            
            {/* --- "Investment Guide" Routes --- */}
            <Route path="/investment-opportunities" element={<InvestmentOpportunities />} />
            <Route path="/housing-schemes-status" element={<HousingSchemesStatus />} />
            <Route path="/future-growth" element={<FutureGrowth />} />
            <Route path="/private-societies" element={<PrivateSocieties />} />
            <Route path="/why-invest" element={<WhyInvest />} />

            <Route path="/dragon-mall" element={<DragonMall />} />

            {/* --- Blog / Insights Routes --- */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />

          </Routes>
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

export default App;